var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLabParameters(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lab Parameters"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    opacity: 0.2,
    d: "M6 7.14014H18V16.1401C18 19.4538 15.3137 22.1401 12 22.1401C8.68629 22.1401 6 19.4538 6 16.1401V7.14014Z",
    fill: "#A461D8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 2.14014C4.44772 2.14014 4 2.58785 4 3.14014C4 3.69242 4.44772 4.14014 5 4.14014H6V16.1401C6 19.4538 8.68629 22.1401 12 22.1401C15.3137 22.1401 18 19.4538 18 16.1401V4.14014H19C19.5523 4.14014 20 3.69242 20 3.14014C20 2.58785 19.5523 2.14014 19 2.14014H18H16H8H6H5ZM16 4.14014H8V16.1401C8 18.3493 9.79086 20.1401 12 20.1401C14.2091 20.1401 16 18.3493 16 16.1401V4.14014Z",
    fill: "#A461D8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 13.1401C13.5523 13.1401 14 12.6924 14 12.1401C14 11.5879 13.5523 11.1401 13 11.1401C12.4477 11.1401 12 11.5879 12 12.1401C12 12.6924 12.4477 13.1401 13 13.1401ZM11 17.1401C11.5523 17.1401 12 16.6924 12 16.1401C12 15.5879 11.5523 15.1401 11 15.1401C10.4477 15.1401 10 15.5879 10 16.1401C10 16.6924 10.4477 17.1401 11 17.1401Z",
    fill: "#A461D8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabParameters);
export default __webpack_public_path__ + "static/media/Lab-Parameters.86c085d9c8f282cfe6037a681572a9d1.svg";
export { ForwardRef as ReactComponent };